import React from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import '../../styles/VBAMaintenance.css';
import ReinsUpdater from './ReinsUpdater';
import ReinsContractImporter from './ReinsContractImporter';
import ReinsContractExporter from './ReinsContractExporter';

function ReinsContract() {
    const [currentTabIndex, setCurrentTabIndex] = React.useState(0);

    const handleTabChange = (_event: React.SyntheticEvent, newValue: number) => {
        setCurrentTabIndex(newValue);
    };

    return (
        <div style={{ height: '100%', width: '100%' }}>
            <React.Fragment>
                <Tabs
                    orientation="vertical"
                    variant="scrollable"
                    value={currentTabIndex}
                    onChange={handleTabChange}
                    aria-label="Reins contract tabs"
                    sx={{
                        borderRight: 1,
                        borderColor: 'divider',
                        borderRadius: '10px',
                        maxWidth: '15%',
                        //takes the tabs out of the layout so they don't push the page down
                        position: 'absolute',
                    }}
                    className="tabStyles"
                >
                    <Tab label="Contract Flipper" style={{ fontWeight: 'bolder' }} />
                    <Tab label="Contract Importer" style={{ fontWeight: 'bolder' }} />
                    <Tab label="Contract Exporter" style={{ fontWeight: 'bolder' }} />
                </Tabs>

                {/*centers the page left to right like the main tab area does*/}
                <div style={{ width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                    {currentTabIndex === 0 && <ReinsUpdater />}
                    {currentTabIndex === 1 && <ReinsContractImporter />}
                    {currentTabIndex === 2 && <ReinsContractExporter />}
                </div>
            </React.Fragment>
        </div>
    );
}

export default React.memo(ReinsContract);
